
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-company",
      function () {
        return require("private-next-pages/our-company.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-company"])
      });
    }
  